(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sober-table-klaviyo-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sober-table-klaviyo-signup')) {
    customElements.define(
      'sober-table-klaviyo-signup',
      class extends HTMLElement {
        connectedCallback() {
          this.embed = this.querySelector('.sober-table-klaviyo-embed');
          this.confirmation = this.querySelector('.sober-table-klaviyo-confirmation');
          this.invitation = this.closest('.email-signup-block')?.previousElementSibling;
          this.hadEmailField = false;
          this.isComplete = false;

          if (!this.embed || !this.confirmation) return;

          this.observer = new MutationObserver(() => this.scheduleSync());
          this.observer.observe(this.embed, { attributes: true, childList: true, subtree: true });
          this.scheduleSync();
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          window.clearTimeout(this.syncTimer);
          this.invitation?.classList.remove('sober-table-newsletter-invitation--hidden');
        }

        scheduleSync() {
          window.clearTimeout(this.syncTimer);
          this.syncTimer = window.setTimeout(() => this.syncState(), 120);
        }

        syncState() {
          const emailField = this.embed.querySelector('input[type="email"]');
          const hasVisibleEmailField = emailField && emailField.getClientRects().length > 0;

          if (hasVisibleEmailField) this.hadEmailField = true;

          const nextComplete = this.hadEmailField && !hasVisibleEmailField;
          if (nextComplete === this.isComplete) return;

          this.isComplete = nextComplete;
          this.classList.toggle('sober-table-klaviyo-signup--complete', nextComplete);
          this.invitation?.classList.toggle('sober-table-newsletter-invitation--hidden', nextComplete);
          this.confirmation.hidden = !nextComplete;

          if (nextComplete) {
            this.embed.setAttribute('aria-hidden', 'true');
            this.confirmation.focus({ preventScroll: true });
          } else {
            this.embed.removeAttribute('aria-hidden');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
